import { Navigate, Outlet, Route } from 'react-router-dom'
import AuthService from "../services/AuthService";

export function PrivateRoute({ children }: any) {
    return AuthService.isLoggedIn() ? children : <Navigate to="/" />;
}